import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IPatolojiYetki {
    yetkiOpen?: boolean;
    yetkiliRaporId?: number;
    yetkiliRaporAdi?: string;
};
export const PatolojiYetkiSlice = createSlice<IPatolojiYetki, MapReducerPayloads<IPatolojiYetki, {
    setYetkiOpen?: boolean;
    setYetkiliRaporId?: number;
    setYetkiliRaporAdi?: string;
}>>({
    name: "patolojiYetki",
    initialState: {
        yetkiOpen: true,
        yetkiliRaporId: 0,
        yetkiliRaporAdi: "",
    },
    reducers: {
        //İlk açılışta HBS_RAPORTIPTANIM içerisinde yetkisi bulunan kayıtların listesini göstermek için set edildiği state
        setYetkiOpen: (state, action) => {
            state.yetkiOpen = action.payload
        },
        //İlk açılışta HBS_RAPORTIPTANIM içerisinde yetkisi seçilen kaydın chip'e idsini yazdıran state
        setYetkiliRaporId: (state, action) => {
            state.yetkiliRaporId = action.payload
        },
        //İlk açılışta HBS_RAPORTIPTANIM içerisinde yetkisi seçilen kaydın chip'e adını yazdıran state
        setYetkiliRaporAdi: (state, action) => {
            state.yetkiliRaporAdi = action.payload
        },
    }
});